import Storage from './Storage';

export const createNonceAndSession = async (
  securityUrl?: string
): Promise<void> => {
  const request = await fetch(`${securityUrl}/nonce`, {
    headers: customHTTPHeader,
  });
  const response = await request.json();
  if (!('nonce' in response && 'sessionID' in response)) {
    throw Error('Invalid response');
  }
  Storage.setItem('nonce', response.nonce);
  Storage.setItem('sessionID', response.sessionID);
};

export const redirectToSSO = (giUrl?: string, clientId?: string): void => {
  const nonce = Storage.getItem('nonce');
  const redirectUrl = encodeURIComponent(window.location.href);
  const url = `${giUrl}/login?clientId=${clientId}&nonce=${nonce}&redirect_uri=${redirectUrl}`;
  window.location.assign(url);
};

export const checkNewRpToken = (): boolean => {
  if (window.location.hash.length) {
    // remove '#' character
    const urlParams = new URLSearchParams(window.location.hash.substring(1));
    const newToken = urlParams.get('rp_token');
    if (newToken) {
      Storage.setItem('rpToken', newToken);
      return true;
    }
  }
  return false;
};

export const customHTTPHeader = { Authorization: 'INSPIRE' };
